// Größe des Admin-Cloud-Videos (HEAD auf den same-origin Stream).
//
// Seit Spec 2026-09-21 § 7 entsteht `_VIDEO.mp4` mit dem Premix bei jedem
// Upload automatisch, wenn die Quelle das Cloud-Video ist — außer das Video
// ist größer als `VIDEO_EXPORT_STREAM_THRESHOLD`, dann fragt das Upload-Modal
// mit einer vorbelegten Checkbox nach. Beides braucht die Größe, bevor der
// Upload startet; sie wird hier einmal je Asset geholt und an Modal und
// Pipeline weitergereicht.
//
// 0 heißt „kein Cloud-Video", `null` „Größe (noch) unbekannt" — die Pipeline
// behandelt null wie ein großes Video, das Modal fragt nach
// (Integrations-Review 2026-09-24; früher galt unbekannt als „klein genug",
// und nach abgelaufener Media-Session ging ein großes Video ungefragt mit).

import { useEffect, useState } from 'react';
import { videoInputSize } from '@/lib/api';

/** @param videoPath Cloud-Pfad des Assets, oder null wenn das Cloud-Video
 *  nicht die Quelle ist (kein `videoPath`, oder das Talent hat ein eigenes
 *  Video geladen). */
export function useCloudVideoSize(
  toolId: string | null | undefined,
  videoPath: string | null | undefined,
): number | null {
  const [size, setSize] = useState<number | null>(0);
  useEffect(() => {
    if (!toolId || !videoPath) {
      setSize(0);
      return;
    }
    let alive = true;
    setSize(null);
    void videoInputSize(toolId, videoPath).then((bytes) => {
      if (alive) setSize(bytes);
    });
    return () => {
      alive = false;
    };
  }, [toolId, videoPath]);
  return size;
}
